import { EXPORT_EMAIL_DRAWER_EN_US } from "#components/export-email-drawer/translations";
import { EXPORT_HISTORY_EN_US } from "#components/export-history/translations";
import withdrawsCards from "#i18n/translations/en-US/components/withdraws-cards.json";
import addBillModalForm from "./add-bill-modal-form.json";
import addProduct from "./add-product.json";
import ballStatusIndicator from "./ball-status-indicator.json";
import bonusReportTotalizers from "./bonus-report-totalizers.json";
import coalaAddMenuModal from "./coala-add-menu-modal.json";
import coalaAddMenuProductModal from "./coala-add-menu-product-modal.json";
import coalaAddProductModal from "./coala-add-product-modal.json";
import coalaCategorizedProductsTable from "./coala-categorized-products-table.json";
import coalaMassEditModal from "./coala-mass-edit-modal.json";
import componentsJson from "./components.json";
import confirmModal from "./confirm-modal.json";
import consolidatedHistory from "./consolidated-history.json";
import containers from "./containers.json";
import dataTable from "./data-table.json";
import datahubChat from "./datahub-chat.json";
import dialogs from "./dialogs.json";
import errorBoundary from "./error-boundary.json";
import eventTag from "./event-tag.json";
import formStatus from "./form-status.json";
import forms from "./forms.json";
import globalWarnings from "./global-warnings.json";
import header from "./header.json";
import helpers from "./helpers.json";
import hierarchicalChartAccountsSelector from "./hierarchical-chart-accounts-selector.json";
import importXlsxDrawer from "./import-xlsx-drawer.json";
import inputFile from "./input-file.json";
import monthPicker from "./month-picker.json";
import notAvailable from "./not-available.json";
import notification from "./notification.json";
import notifications from "./notifications.json";
import openSalesReport from "./open-sales-report.json";
import paginator from "./paginator.json";
import pendingContracts from "./pending-contracts.json";
import periodDropdown from "./period-dropdown.json";
import pixTypeInput from "./pix-type-input.json";
import placeCheckbox from "./place-checkbox.json";
import placeFilter from "./place-filter.json";
import reconciliationTransactions from "./reconciliation-transactions.json";
import reportNavbar from "./report-navbar.json";
import reportPrintTemplate from "./report-print-template.json";
import reportTab from "./report-tab.json";
import reportTabs from "./report-tabs.json";
import selectImage from "./select-image.json";
import tableEmptyState from "./table-empty-state.json";
import table from "./table.json";
import tabsBackoffice from "./tabs-backoffice.json";
import transactionalHistory from "./transactional-history.json";
import xlsx from "./xlsx.json";

export const componentsEN = {
	...componentsJson,
	pixTypeInput,
	periodDropdown,
	confirmModal,
	eventTag,
	paginator,
	dataTable,
	monthPicker,
	notification,
	notAvailable,
	openSalesReport,
	formStatus,
	reportNavbar,
	reportTab,
	selectImage,
	table,
	tabsBackoffice,
	addBillModalForm,
	ballStatusIndicator,
	coalaAddMenuModal,
	coalaAddMenuProductModal,
	coalaAddProductModal,
	coalaCategorizedProductsTable,
	coalaMassEditModal,
	containers,
	dialogs,
	errorBoundary,
	forms,
	globalWarnings,
	consolidatedHistory,
	addProduct,
	pendingContracts,
	reportTabs,
	transactionalHistory,
	helpers,
	withdrawsCards,
	reportPrintTemplate,
	inputFile,
	notifications,
	placeCheckbox,
	placeFilter,
	header,
	tableEmptyState,
	bonusReportTotalizers,
	xlsx,
	importXlsxDrawer,
	"hierarchical-chart-accounts-selector": hierarchicalChartAccountsSelector,
	exportHistory: EXPORT_HISTORY_EN_US,
	datahubChat,
	exportEmailDrawer: EXPORT_EMAIL_DRAWER_EN_US,
	reconciliationTransactions,
};
